
const cache = {};

export default {
    loadImage(url,index)
    {
        let currIndex = index;
        return new Promise((resolve, reject)=>{
            let img = cache[url];
            if( img ) {
                resolve({img, index:currIndex});
                return;
            }
            img = new Image;
            img.src = url;
            img.onload = function(){
                resolve({img, index:currIndex});
            }
        });
    },

    loaderImages(prefix, suffix, total, callback)
    {
        let reqs = [];
        for(let i=0; i<total; i++){
            let index = i;
            if( i< 10 ) {
                index = '00'+i;
            } else if( i<100 ) {
                index = '0' + i;
            } 
            let url = prefix + `${index}` + suffix;
            reqs.push( this.loadImage(url, i));
        }

        return new Promise((resolve)=>{
            Promise.all(reqs).then(rets=>{
                let images = {};
                rets.forEach(item=>{
                   images[item.index] = item.img;
                })
                callback && callback( images );
                resolve( images );
            });
        }) 
    }
}